import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const cigarProductionPlansApi = {
  create: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/cigar-production-plans`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  get: async (params: { includeCompleted?: boolean } = {}) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigar-production-plans`, {
        params,
      });
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getById: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigar-production-plans/${id}`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getSummary: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigar-production-plans/${id}/summary`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getSummaries: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigar-production-plans/summaries`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  update: async (data, id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/cigar-production-plans/${id}`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  remove: async (id) => {
    try {
      const res = await axiosApiInstance.delete(`${apiRoot}/cigar-production-plans/${id}`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  takeInWork: async (id: string, data: any) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/cigar-production-plans/${id}/take-in-work`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  checkTasksExist: async (id: string) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigar-production-plans/${id}/tasks-exist`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getAttributionLogs: async (params: { planId?: string; taskId?: string; limit?: number; offset?: number } = {}) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigar-production-plans/attribution-logs`, {
        params,
      });
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getAttributionQuantity: async (params: { planId?: string; taskId?: string } = {}) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigar-production-plans/attribution-quantity`, {
        params,
      });
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  syncActualProductionV2: async (id: string) => {
    try {
      const res = await axiosApiInstance.post(
        `${apiRoot}/cigar-production-plans/summaries/${id}/sync-actual-production-v2`
      );
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default cigarProductionPlansApi;
